import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Collapse, Button, Box } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import { PaginationWithLimit } from "../../../../components/ui";
import AddNoteForm from "../AddNoteForm";
import usePagination from "../../../../hooks/usePagination";

import { fundedTraderActions } from "../../../../reducers/fundedTrader";
import { APIFunds } from "../../../../api";
import FundedTraderNotes from "../FundedTraderNotes";

const FundedProfileNotesTable = (): React.ReactElement => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const id = +params.id;
  const { limit, setLimit, setPage, page } = usePagination(5);

  const { count } = useSelector((state) => state.fundedTrader.notes);
  const [open, setOpen] = useState(false);

  const fetchFundedTraderNotes = async (): Promise<void> => {
    try {
      dispatch(fundedTraderActions.notesFetchRequest());
      const response = await APIFunds.getFundedAccountNotesRequest(id, { limit: +limit, page });
      dispatch(fundedTraderActions.notesFetchSuccess(response));
    } catch (error) {
      console.error("Error fetching funded account notes");
      dispatch(fundedTraderActions.notesFetchFailed());
    }
  };

  const handleExpand = () => setOpen(!open);

  useEffect(() => {
    (async () => {
      await fetchFundedTraderNotes();
    })();
  }, [limit, page]);

  useEffect(() => {
    setPage(0);
  }, [limit]);

  return (
    <Box sx={{ mt: "5px" }}>
      <Button size="small" onClick={handleExpand}>
        Notes:
        {open ? (
          <ExpandLess sx={{ cursor: "pointer" }} />
        ) : (
          <ExpandMore sx={{ cursor: "pointer" }} data-test="expand-notes" />
        )}
      </Button>
      {/*<b style={{ display: "block", margin: "10px 0" }}>Notes</b>*/}
      <Collapse in={open} timeout="auto" unmountOnExit sx={{ mt: "5px" }}>
        <Box
          sx={{
            border: "1px solid rgba(0,0,0,.2)",
            borderRadius: "10px",
            p: "7px",
          }}
        >
          <AddNoteForm fetchFundedTraderNotes={fetchFundedTraderNotes} />

          <FundedTraderNotes fetchFundedTraderNotes={fetchFundedTraderNotes} />
          <div>
            <PaginationWithLimit
              count={count}
              limit={limit}
              page={page}
              setLimit={setLimit}
              setPageState={setPage}
            />
          </div>
        </Box>
      </Collapse>
    </Box>
  );
};

export default FundedProfileNotesTable;
